import { render } from "./StatsWidgetTitle.vue?vue&type=template&id=9db66544&scoped=true"
import script from "./StatsWidgetTitle.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetTitle.vue?vue&type=script&lang=ts"

import "./StatsWidgetTitle.vue?vue&type=style&index=0&id=9db66544&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9db66544"

export default script